import { createAccessControl } from "better-auth/plugins/access";
import { adminAc, defaultStatements } from "better-auth/plugins/admin/access";

/*
 * All available permissions
 */
const statement = {
  ...defaultStatements,
  deal: ["view", "create", "update", "delete"],
  invoice: ["send-email"],
} as const;

export const ac = createAccessControl(statement);

/*
 * Permissions based on roles.
 * Anyone with an account will have the "user" role. So it needs to have the bare minimum permissions
 * The role names are in snake_case because they correspond to the enum value in database
 */

export const user = ac.newRole({
  deal: ["view", "create", "update", "delete"],
});

export const admin = ac.newRole({
  deal: ["view", "create", "update", "delete"],
  invoice: ["send-email"],
});

export const super_admin = ac.newRole({
  ...adminAc.statements,
});

/* Make sure to add the role to database enum whenever a new role is added */
export const roles = { user, admin, super_admin };
export const roleNames = Object.keys(roles) as Role[];

export type PermissionsToCheck = {
  [K in keyof typeof statement]?: (typeof statement)[K][number][];
};
export type Role = keyof typeof roles;
